(function () {
  const GRID_SELECTOR = '#CollectionProductGrid';
  let isLoading = false;

  document.addEventListener(
    'click',
    async function (e) {
      const item = e.target.closest('[data-custom-nfc-tab]');
      if (!item) return;

      const link = item.querySelector('a');
      if (!link) return;

      e.preventDefault();
      e.stopImmediatePropagation(); // 🔥 KILLS Minimog handler

      if (isLoading) return;
      isLoading = true;

      const url = link.href;
      const grid = document.querySelector(GRID_SELECTOR);
      if (!grid) return;

      // Active state
      document
        .querySelectorAll('[data-custom-nfc-tab].active')
        .forEach(el => el.classList.remove('active'));
      item.classList.add('active');

      grid.classList.add('is-loading');

      try {
        const res = await fetch(url, { credentials: 'same-origin' });
        const html = await res.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');

        const newGrid = doc.querySelector(GRID_SELECTOR);
        if (!newGrid) throw new Error('Grid not found');

        grid.replaceWith(newGrid);

        // Update URL without reload
        history.pushState({}, '', url);

        // Optional: scroll
        newGrid.scrollIntoView({ behavior: 'smooth', block: 'start' });
      } catch (err) {
        console.error('[Custom NFC Tabs]', err);
        window.location.href = url; // safe fallback
      } finally {
        isLoading = false;
      }
    },
    true // 🔥 CAPTURE PHASE (runs BEFORE Minimog)
  );
})();

function initNfcSidebarScroll() {
  const wrapper = document.querySelector('.nfc-scroll-wrapper');
  if (!wrapper) return;

  // Use wrapper itself as scroll area (Option A)
  const scrollArea = wrapper;
  const btnUp = wrapper.querySelector('.nfc-scroll-up');
  const btnDown = wrapper.querySelector('.nfc-scroll-down');

  if (!btnUp || !btnDown) return;

  const STEP = 180;

  function updateButtons() {
    btnUp.classList.toggle('is-hidden', scrollArea.scrollTop <= 0);
    btnDown.classList.toggle(
      'is-hidden',
      scrollArea.scrollTop + scrollArea.clientHeight >= scrollArea.scrollHeight - 1
    );
  }

  btnUp.onclick = () => {
    scrollArea.scrollBy({ top: -STEP, behavior: 'smooth' });
  };

  btnDown.onclick = () => {
    scrollArea.scrollBy({ top: STEP, behavior: 'smooth' });
  };

  scrollArea.addEventListener('scroll', updateButtons);
  updateButtons();
}

// Initial load
window.addEventListener('load', initNfcSidebarScroll);

// VERY important for Minimog
document.addEventListener('shopify:section:load', initNfcSidebarScroll);
document.addEventListener('shopify:section:select', initNfcSidebarScroll);
document.addEventListener('shopify:section:reorder', initNfcSidebarScroll);

